module.exports = __webpack_public_path__ + "img/offer-icon.fd44f400.svg";